import { useEffect, useState } from 'react';
import { pendingCount } from '../lib/offline';
import { syncQueue } from '../api';

// Indique l'absence de réseau et les enregistrements en attente de synchronisation
export default function SyncBanner() {
  const [online, setOnline] = useState(() => navigator.onLine);
  const [pending, setPending] = useState(() => pendingCount());

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    const queue = (e) => setPending(e.detail);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    window.addEventListener('muscuapp:queue', queue);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
      window.removeEventListener('muscuapp:queue', queue);
    };
  }, []);

  if (online && !pending) return null;
  return (
    <div className={'sync-banner' + (online ? ' sync-banner--pending' : '')} role="status">
      {online ? (
        <>
          <span>🔄 {pending} enregistrement{pending > 1 ? 's' : ''} à synchroniser</span>
          <button type="button" className="btn btn-sm btn-ghost" onClick={() => syncQueue().catch(() => {})}>Synchroniser</button>
        </>
      ) : (
        <span>📴 Hors ligne{pending ? ` — ${pending} enregistrement${pending > 1 ? 's' : ''} en attente` : ' — tes saisies seront synchronisées au retour du réseau'}</span>
      )}
    </div>
  );
}
